<template>
  <div class="post-wrap" v-bar>
    <div class="infinite-list">
      <template v-if="posts.length">
        <el-card
          :id="`${+post.id + post.owner_id}`"
          :class="`card card--${
            post.trust.trust == 1
              ? 'positive'
              : post.trust.trust == -1
              ? 'negative'
              : 'netural'
          }`"
          v-for="(post, index) in posts"
          :key="index"
        >
          <div class="card-margin post-item">
            <div class="card-inner">
              <post-header :post="post" :info="info" class="post-header" @loadPosts="loadPosts"/>

              <div v-if="info" style="display: flex; align-items: center;">
                Тема:
                <ul class="post-info">
                  <li v-for="item in post.object" :key="item">
                    {{item}}
                    <el-tooltip effect="light" content="Удалить тему поста" placement="right" :key="post.id">
                      <img src="../../../../../../../assets/img/trash.svg" @click="showDeliteInfo(post.inner_id, post.network_id, item, 'object')" class="edit" width="10px" style="padding-top: 3px; padding-left: 0px">
                    </el-tooltip>
                  </li>
                </ul>
                <el-tooltip effect="light" content="Добавить тему поста" placement="right" :key="post.id">
                  <img src="../../../../../../../assets/img/plus.svg" @click="showEditInfo(post.inner_id, post.network_id, 'object')" class="edit" width="16px" v-if="!post.repost.id">
                </el-tooltip>
              </div>
              <post-body :post="post" :isRepost="false" @setTrust="setTrust" />
              <post-header
                v-if="!!post.repost.id"
                :isRepost="!!post.repost.id"
                :post="post.repost"
                @loadPosts="loadPosts"
                class="post-header"
              />
              <post-body
                v-if="post.repost.id"
                :post="post.repost"
                :isRepost="true"
                @setTrust="setTrust"
              />

              <div
                class="add-post-and-event"
                v-if="addPostToEvent && showOnMap"
              >
                <el-button size="mini" round @click="addPostTo(post)"
                  >Добавить к событию</el-button
                >
              </div>

                <ul class="post-info"  v-if="info">
                  <li v-for="item in post.subject" :key="item">
                    {{item}}
                    <el-tooltip effect="light" content="Удалить субъект" placement="right" :key="post.id">
                      <img src="../../../../../../../assets/img/trash.svg" @click="showDeliteInfo(post.inner_id, post.network_id, item, 'subject')" class="edit" width="10px" style="padding-top: 3px; padding-left: 0px">
                    </el-tooltip>
                  </li>
                  <el-tooltip effect="light" content="Добавить субъект" placement="right" :key="post.id">
                  <img src="../../../../../../../assets/img/plus.svg" @click="showEditInfo(post.inner_id, post.network_id, 'subject')" class="edit" width="16px" v-if="!post.repost.id">
                </el-tooltip>
                </ul>


              <div class="post-info-panel">
                <div>
                  <span
                    v-if="
                      Number(post.comments) &&
                      (post.network_id == '1' ||
                        post.network_id == '5' ||
                        post.network_id == '8')
                    "
                    class="post-info-panel__item post-info-panel__item--comments"
                    @click="toggleComment(post)"
                    >{{ $t("post.postInfoPanel.comments") }} -
                    {{ post.comments }}</span
                  >
                </div>
                <div>
                  <!--<span class="post-info-panel__item" @click="showPostInfo(post)">{{$t('post.postInfoPanel.analysis')}}</span>-->
                  <!--<span class="post-info-panel__item" @click="showPostCopy(post)" v-if="post.network_id !== '4'">Посмотреть одинаковые посты</span>-->
                  <!--<span class="post-info-panel__item" @click="showChangeTonal(post)">Изменить тональность</span>-->
                  <span
                    class="post-info-panel__item to-ex is-removed"
                    v-if="post.isRemoved"
                    @click="addToPosts(post)"
                    >Пост будет исключен из выдачи. Вернуть</span
                  >
                  <!--<span class="post-info-panel__item to-ex" v-if="excluded && !post.isRemoved" @click="addStopPost(post)">{{$t('post.postInfoPanel.exclude')}}</span>-->
                  <span
                    class="post-info-panel__item to-ex"
                    v-if="!excluded"
                    @click="addToAllPost(post)"
                    >{{ $t("post.postInfoPanel.back") }}</span
                  >
                  <!-- <div
                    class="post-info-panel__item"
                    v-if="showMoreButton(post) && !!post.repost.id"
                  >
                    <span
                      v-if="
                        moreButton.full.findIndex(
                          (it) => it == +post.id + post.owner_id
                        ) == -1
                      "
                      @click="showMore(post)"
                      >{{ $t("post.postInfoPanel.more") }}</span
                    >
                    <a
                      class="post-info-panel__item"
                      v-if="
                        moreButton.full.findIndex(
                          (it) => it == +post.id + post.owner_id
                        ) != -1
                      "
                      @click="showMore(post)"
                      >Скрыть</a
                    >
                  </div> -->
                </div>
              </div>

              <div class="post-info-panel--mobile">
                <div class="post-info-panel--group">
                  <span
                    class="post-info-panel__item"
                    v-if="showMoreButton(post)"
                    @click="showMore(post)"
                    >{{ $t("post.postInfoPanel.more") }}</span
                  >
                </div>
                <div class="post-info-panel--group">
                  <span
                    class="post-info-panel__item to-ex"
                    v-if="excluded"
                    @click="addStopPost(post)"
                    >{{ $t("post.postInfoPanel.exclude") }}</span
                  >
                  <span
                    class="post-info-panel__item to-ex"
                    v-if="!excluded"
                    @click="addToAllPost(post)"
                    >{{ $t("post.postInfoPanel.back") }}</span
                  >
                  <span
                    class="post-info-panel__item"
                    @click="showPostCopy(post)"
                    v-if="post.network_id !== '4'"
                    >Одинаковые посты</span
                  >
                </div>

                <div class="post-info-panel--group">
                  <span
                    class="post-info-panel__item"
                    @click="showPostInfo(post)"
                    >{{ $t("post.postInfoPanel.analysis") }}</span
                  >
                  <span
                    v-if="Number(post.comments)"
                    class="post-info-panel__item"
                    @click="toggleComment(post)"
                    >{{ $t("post.postInfoPanel.comments") }} -
                    {{ post.comments }}</span
                  >
                </div>
              </div>

              <gallery v-if="post.images.length" :images="post.images" />
              <template
                v-if="post.repost && post.repost.id && post.repost.images"
              >
                <gallery
                  v-if="post.repost.images.length"
                  :images="post.repost.images"
                />
              </template>

              <audio-gallery v-if="post.audio.length" :audios="post.audio" />
              <template v-if="post.repost.id">
                <audio-gallery
                  v-if="post.repost.audio.length"
                  :audios="post.repost.audio"
                />
              </template>

              <video-gallery v-if="post.video.length" :videos="post.video" />
              <template v-if="post.repost.id">
                <video-gallery
                  v-if="post.repost.video.length"
                  :videos="post.repost.video"
                />
              </template>

              <commentaries :post="post" v-if="!post.repost.id" />
            </div>
          </div>
          <div class="post-options">
            <el-tooltip
              class="item"
              effect="light"
              content="Изменить тональность"
              placement="top"
            >
              <post-trust
                :post="post"
                :isRepost="false"
                @setTrust="setTrust"
                @showChangeTonal="showChangeTonal"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="Анализ поста"
              placement="top"
            >
              <i class="material-icons color_grey" @click="showPostInfo(post)">
                leaderboard
              </i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="Исключить пост"
              placement="top"
            >
              <i
                class="material-icons color_grey"
                v-if="!post.isRemoved"
                @click="addStopPost(post)"
              >
                cancel_presentation
              </i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="Посмотреть одинаковые посты"
              placement="top"
            >
              <i
                class="material-icons color_grey"
                @click="showPostCopy(post)"
                v-if="post.network_id !== '4'"
              >
                file_copy
              </i>
            </el-tooltip>
          </div>
        </el-card>
      </template>
      <template v-else>
        <div class="posts__not-result">
          <i class="el-icon-search"></i> {{ $t("post.noData") }}
        </div>
      </template>
    </div>

    <el-dialog
      :title="`${$t('post.postInfoPanel.analysis')} ${selectedPost.title}`"
      :visible.sync="dialogPostInfo"
    >
      <post-info
        :post="selectedPost"
        :gridData="gridData"
        :loading="loading"
        :postInfo="postInfo"
        :age_from="postInfo.age_from"
        :age_to="postInfo.age_to"
      />
    </el-dialog>

    <el-dialog :visible.sync="dialogPostCopy">
      <div class="copy-posts-head" slot="title">
        <span class="copy-posts-title">Копии поста</span>
        <div class="copy-posts-actions">
          <el-button
            type="primary"
            v-if="!copyRemoved"
            :disabled="loadCopyPosts"
            size="small"
            @click="addAllCopyStopPost"
            >Исключить все</el-button
          >
          <el-button
            type="primary"
            v-if="copyRemoved"
            size="small"
            @click="removeAllCopyStopPost"
            >Восстановить все</el-button
          >
        </div>
      </div>
      <div class="copy-posts-wrap">
        <post-copy
          :posts="copyPosts"
          :excluded="excluded"
          :copyRemoved="copyRemoved"
          v-loading="loadCopyPosts"
        />
      </div>
    </el-dialog>

    <el-dialog title="Тональность" :visible.sync="dialogChangeTonal">
      <div class="change-post-tonal-modal">
        <div class="change-post-tonal-modal__wrap">
          <div class="change-post-tonal-modal__list">
            <div
              :class="`change-post-tonal-modal__item positive${
                selectedTonal === 1 ? ' active' : ''
              }`"
              @click="setSelectedTonal(1)"
            >
              Положительная
            </div>
            <div
              :class="`change-post-tonal-modal__item${
                selectedTonal === 0 ? ' active' : ''
              }`"
              @click="setSelectedTonal(0)"
            >
              Нейтральная
            </div>
            <div
              :class="`change-post-tonal-modal__item negative${
                selectedTonal === -1 ? ' active' : ''
              }`"
              @click="setSelectedTonal(-1)"
            >
              Негативная
            </div>
          </div>
          <div class="change-post-tonal-modal__all" @click="toggleIsAllTonal()">
            <div :class="`checkbox${isAllTonal ? ' active' : ''}`" />
            <span>Для всех публикаций</span>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="hideChangeTonal()">Отмена</el-button>
        <el-button type="primary" @click="setTrustAllPage()"
          >Добавить</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="`Добавить ${currentType == 'object' ? ' тему' : ' субъект'} поста`"
      :visible.sync="dialogEditInfo"
    >
      <p>Выполните поиск нужного значения:</p>
      <el-input v-model="searchString" @input.native="onChange" :class="inputClass" placeholder="Поиск" v-loading="loading">
        <el-button @click="onSelect" slot="append" type="primary">
          <i class="material-icons">
            search
          </i>
        </el-button>
      </el-input>
      <div v-if="showSelect">
        <p>Выберите подходящий вариант на основе поиска:</p>
          <el-select v-model="selectString" class="el-input-group">
            <el-option
              v-for="item in gridData"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
          </el-select>
      </div>
      <p v-if="showCheckbox && !showSelect" style="color: #409EFF">Поиск не дал результатов</p>
      <p>Если подходящего варианта не найдено, можно добавить новое значение:</p>
      <el-checkbox :disabled="!showCheckbox" v-model="notDefined" label="Нет подходящего варианта"></el-checkbox>
      <br>
      <el-button @click="onReset(post)" v-if="!notDefined" :disabled="selectString.length == 0"  type="primary" style="margin: 10px 0">
        Добавить {{currentType == 'object' ? ' тему' : ' субъект'}} {{selectString}}
      </el-button>
      <br>
      <el-button @click="onReset(post)" v-if="notDefined" :disabled="searchString.length < 2" type="primary" style="margin: 10px 0">
        Добавить {{currentType == 'object' ? ' тему' : ' субъект'}} {{searchString}}
      </el-button>
    </el-dialog>
    <el-dialog
      :title="`Удалить ${currentType == 'object' ? ' тему' : ' субъект'} поста`"
      :visible.sync="dialogDeliteInfo"
    >
    <p>Вы уверены, что хотите удалить {{currentType == 'object' ? ' тему' : ' субъект'}} "{{currentString}}" ?</p>

      <el-button @click="onDelite(post)" type="primary" style="margin: 10px 0">
        Удалить {{currentType == 'object' ? ' тему' : ' субъект'}} 
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
// components
import PostCopy from "./PostCopy";
import PostHeader from "./PostHeader";
import PostBody from "./PostBody";
import Commentaries from "./Commentaries";
import Gallery from "./Gallery";
import VideoGallery from "./VideoGallery";
import AudioGallery from "./AudioGallery";
import PostInfo from "./PostInfo";
import PostTrust from "./PostTrust";

// api
import {
  getSentimentAutocompleteApi, updatePostSentimentApi, removePostSentimentApi,
  getPostSiblings,
  getPostInfoApi,
} from "../../../../../../../api/publications";
import { getStatsParamsApi} from '../../../../../../../api/feeds';

export default {
  name: "Posts",
  props: {
    posts: {
      type: Array,
    },
    excluded: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    addPostToEvent: {
      type: Boolean,
      default: false,
    },
    setTrustAllPageCompleted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogPostCopy: false,
      selectedPost: {},
      gridData: {},
      info: false,
      // loading: false,
      copyRemoved: false,
      dialogPostInfo: false,
      position: 0,
      trimTextLength: 400,
      copyPosts: [],
      loadCopyPosts: false,
      dialogChangeTonal: false,
      selectedTonal: null,
      postToChangeTonal: {},
      isAllTonal: false,
      moreButton: {
        id: 0,
        full: [],
      },
      postInfo: {
        age_from: 32,
        age_to: 52,
      },
        dialogEditInfo: false,
        dialogDeliteInfo: false,
        gridData: {},
        searchString: "",
        selectString: "",
        currentString: "",
        currentType:"",
        showSelect: false,
        currentNetworkId: "",
        currentInnerId: "",
        notDefined: false,
        showCheckbox: false,
    };
  },
  computed: {
    feed() {
      return this.$store.getters["feed"](this.$route.params.threadId)
        ? this.$store.getters["feed"](this.$route.params.threadId)
        : [];
    },
    showOnMap() {
      return this.feed.show_at_map;
    },
    inputClass() {
      return this.error ? "input-with-select input-with-select--error" : "input-with-select";
    }
  },
  methods: {
      loadThreadExtended() {
        let params = {
          thread_id: parseInt(this.$route.params.threadId)
        };

        getStatsParamsApi(params).then((resp) => {
          this.info = resp.data.extended_sentiment;
        });
      },
      showEditInfo(id, network, type) {
        this.dialogEditInfo = true;
        this.searchString = ""
        this.selectString = ""
        this.currentType = type
        this.currentInnerId = id
        this.currentNetworkId = network
      },

      showDeliteInfo(id, network, value, type) {
        this.dialogDeliteInfo = true;
        this.currentString = value
        this.currentType = type
        this.currentInnerId = id
        this.currentNetworkId = network
      },

    onChange(event) {
      this.searchString = event.target.value;
      this.showSelect = false
      this.showCheckbox = false
      this.notDefined = false
      this.selectString = ""
    },

    onSelect() {
      if (this.searchString.length > 2)
        {
        
        this.loading = true;
        let params = {
          type: this.currentType,
          search: this.searchString
        };

        getSentimentAutocompleteApi(params)
          .then((resp) => {
            this.showCheckbox = true
            if (resp.data[0]) this.showSelect = true;
            this.gridData = {...resp.data};
            this.loading = false;
          })
          .catch((this.loading = true));}
    },
    onReset() {
      this.loading = true;
        let params = {
          post_id: this.currentInnerId,
          network_id: this.currentNetworkId,
          type: this.currentType,
          value: this.notDefined ? this.searchString : this.selectString
        };
        updatePostSentimentApi(params)
          .then((resp) => {
            this.showCheckbox = true
            if (resp.data[0]) this.showSelect = true;
            this.currentType = "";
            this.currentInnerId = ""
            this.currentNetworkId = ""
            this.searchString = ""
            this.selectString = ""
            this.dialogEditInfo = false;
            this.loading = false;
            this.$emit('loadPosts')
          })
          .catch((this.loading = true));
    },
    onDelite() {
      this.loading = true;
        let params = {
          post_id: this.currentInnerId,
          network_id: this.currentNetworkId,
          type: this.currentType,
          value: this.currentString
        };
        removePostSentimentApi(params)
          .then((resp) => {
            if (resp.data[0]) this.showSelect = true;
            this.dialogDeliteInfo = false;
            this.currentType = "";
            this.currentInnerId = ""
            this.currentNetworkId = ""
            this.searchString = ""
            this.selectString = ""
            this.loading = false;
            this.$emit('loadPosts')
          })
          .catch((this.loading = true));
    },
    addPostTo(post) {
      this.$emit("addPostTo", post);
    },
    showPostCopy(post) {
      this.copyPosts = [];
      this.loadCopyPosts = true;
      this.dialogPostCopy = true;

      let params = {
        id: post.id,
        owner_id: post.owner_id,
        network_id: post.network_id,
      };

      getPostSiblings(params).then((resp) => {
        this.loadCopyPosts = false;
        this.copyPosts = resp.data.posts;
      });
    },
    showChangeTonal(post) {
      this.selectedTonal = post.trust.trust;
      this.postToChangeTonal = post;
      this.dialogChangeTonal = true;
    },
    setSelectedTonal(value) {
      this.selectedTonal = value;
    },
    toggleIsAllTonal() {
      this.isAllTonal = !this.isAllTonal;
    },
    hideChangeTonal() {
      this.selectedTonal = null;
      this.isAllTonal = false;
      this.dialogChangeTonal = false;
    },
    showPostInfo(post) {
      this.selectedPost = { ...this.selectedPost, ...post };
      this.dialogPostInfo = true;
      this.loading = true;

      let params = {
        post_link: post.uri,
        age_from: this.postInfo.age_from,
        age_to: this.postInfo.age_to,
      };

      getPostInfoApi(params)
        .then((resp) => {
          this.gridData = { ...this.gridData, ...resp.data };
          this.loading = false;
        })
        .catch((this.loading = true));
    },
    getShowPost(showPost) {
      return !showPost ? "hidePost" : "";
    },
    addStopPost(post) {
      this.$emit("addStopPost", post);
    },
    addAllCopyStopPost() {
      this.$emit("addAllCopyStopPost", this.copyPosts);
      this.copyRemoved = true;
      this.excluded = false;
    },
    removeAllCopyStopPost() {
      this.$emit("removeAllCopyStopPost", this.copyPosts);
      this.copyRemoved = false;
    },
    addToAllPost(post) {
      this.$emit("addToAllPost", post);
    },
    addToPosts(post) {
      this.$emit("removeStopPost", post);
    },
    showMoreButton(post) {
      return post.text.length > this.trimTextLength;
    },
    showMore(post) {
      if (
        this.moreButton.full.findIndex(
          (it) => it == +post.id + post.owner_id
        ) != -1
      ) {
        this.$emit("showMore", post);
        //this.moreButton.id = +post.id+post.owner_id
        this.moreButton.id = 1;
        let i = this.moreButton.full.findIndex(
          (it) => it == +post.id + post.owner_id
        );
        this.moreButton.full.splice(i, 1);
      } else if (
        this.moreButton.full.findIndex(
          (it) => it == +post.id + post.owner_id
        ) == -1
      ) {
        this.$emit("showMore", post);
        this.moreButton.id = 0;
        this.moreButton.full.push(+post.id + post.owner_id);
      }
      //else if (this.moreButton.id != +post.id+post.owner_id)
      //{
      //  this.$emit('showMore', this.moreButton.full);
      //  this.$emit('showMore', post)
      //  //this.moreButton.id = +post.id+post.owner_id
      //  this.moreButton.full = post
      //}
      else this.$emit("showMore", post);

      console.log("ghj", this.moreButton.full);
    },
    toggleComment(post) {
      this.$emit("toggleComment", post);
    },
    setTrust({ postId, trust }) {
      if (trust == 0) this.dialogChangeTonal = true;
      else this.$emit("setTrust", { postId, trust });
    },
    loadPosts() {
      this.$emit("loadPosts");
    },
    setTrustAllPage() {
      const trust = this.selectedTonal;
      const post = this.postToChangeTonal;
      if (this.isAllTonal) {
        this.$emit("setTrustAllPage", trust);
      } else {
        this.$emit("setTrust", { postId: post.id, trust });
      }
      this.dialogChangeTonal = false;
    },
    load($event) {
      if (!$event) {
        return;
      }
      const element = $event.target;

      this.updateContentScrollPosition(element);

      if (
        parseInt((element.scrollHeight - element.scrollTop).toFixed()) ===
        element.clientHeight
      ) {
        this.$emit("loadPosts");
      }
    },
    updateContentScrollPosition(element) {
      this.position = element.scrollTop;
    },
  },
  components: {
    PostHeader,
    PostBody,
    Commentaries,
    Gallery,
    VideoGallery,
    AudioGallery,
    PostInfo,
    PostCopy,
    PostTrust,
  },
  mounted() {
    this.load();
    this.loadThreadExtended()
  },
};
</script>

<style>
.material-icons {
  color: darkgrey;
}
.post-options .material-icons {
  cursor: pointer;
}
.add-post-and-event {
  box-sizing: border-box;
  padding-left: 55px;
}
.el-tabs__content {
  overflow: visible;
}
.post-wrap {
  padding: 0 0 15px 0;
  margin-top: -15px;
  background-color: #eee;
  height: auto;
  overflow: visible !important;
}
.infinite-list {
  padding-top: 20px;
  overflow: auto !important;
  width: 100% !important;
}
.card-margin {
  margin-bottom: 20px;
  position: relative;
  border-radius: 0;
  background-color: #f5f7fa;
  background: white;
}

.el-card {
  border: none;
  background-color: unset;
  box-shadow: none;
}
.el-card.card {
  overflow: visible;
}
.card--netural > .el-card__body,
.card--negative > .el-card__body,
.card--positive > .el-card__body {
  display: flex;
  padding: 0 33px;
  box-shadow: none;
}
.post-item {
  /*width: 93%;*/
  flex-grow: 1;
  box-shadow: 0 8px 15px rgb(0 0 0 / 10%);
  transition: 0.2s linear;
}
.el-card:hover .post-item,
.el-card:hover .post-options {
  box-shadow: 0 10px 12px 0 rgb(0 0 0 / 30%);
}
.el-card.is-always-shadow {
  box-shadow: none;
}
.card-inner {
  padding: 20px;
  background: #fff;
}
.copy-posts-wrap .card-inner {
  width: 100%;
}

.card--negative .card-inner {
  background: linear-gradient(
      -90deg,
      rgba(255, 255, 255, 0.1),
      rgba(255, 51, 0, 0.12)
    ),
    linear-gradient(
      90.03deg,
      rgba(0, 224, 22, 0.07) 0.3%,
      rgba(0, 224, 22, 0) 42.37%
    );
}

.card--positive .card-inner {
  background: linear-gradient(
      -90deg,
      rgba(255, 255, 255, 0.1),
      rgba(153, 255, 102, 0.4)
    ),
    linear-gradient(
      90.03deg,
      rgba(0, 224, 22, 0.07) 0.3%,
      rgba(0, 224, 22, 0) 42.37%
    );
}

.el-image__error,
.el-image__inner,
.el-image__placeholder {
  width: 100%;
  height: unset;
}

.el-image {
  vertical-align: text-top;
  margin: auto 5px;
  width: 100px;
  height: 70px;
  overflow: hidden;
  position: relative;
}

.post-info{
  padding: 0;
  margin: 0;
}

.post-info li{
    background: #e8e7e7;
    border-radius: 10px;
    padding: 2px 6px;
    margin: 3px;
    display: inline-block;
    list-style: none;
    font-size: 13px;
}

.post-options {
  flex-shrink: 0;
  position: inherit;
  opacity: 1;
  transition: all 0.1s linear;
  background: #fff;
  background-position: 0;
  background-repeat: no-repeat;
  background-size: 64px 128px;
  border-radius: 0;
  box-shadow: 0 8px 15px rgb(0 0 0 / 10%);
  margin-left: 10px;
  margin-bottom: 20px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  width: 25px;
  align-items: center;
  justify-content: center;
}

.post-header {
  margin-bottom: 20px;
}

.post-info-panel {
  display: flex;
  justify-content: space-between;
  margin-left: 45px;
  padding: 15px 0 0 10px;
}

.post-info-panel div {
  display: flex;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #1f2f3d;
}

.post-info-panel--mobile {
  display: none;
}

.post-info-panel__item {
  cursor: pointer;
  text-decoration: none;
  color: black;
}
.post-info-panel__item.post-info-panel__item--comments {
  margin-right: auto;
}
.post-info-panel__item:last-child {
  margin-right: 0;
}
.posts__not-result {
  border-top: 1px solid #ccc;
  padding-top: 20px;
}
.to-ex {
  margin-left: auto;
  margin-right: 10px;
}

.copy-posts-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 480px) {
  .post-info-panel {
    padding: 0;
  }
  .post-info-panel__item:last-child {
    max-width: 50px;
  }
  .post-info-panel--mobile {
    display: flex;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #1f2f3d;
    margin-left: 45px;
    padding: 15px 0 0 10px;
    flex-wrap: wrap;
    display: none;
  }
  .card--netural > .el-card__body,
  .card--negative > .el-card__body,
  .card--positive > .el-card__body {
    display: flex;
    padding: 0;
    box-shadow: none;
  }
  .post-info-panel--group {
    display: flex;
    width: 100%;
  }
  .post-info-panel__item {
    margin-bottom: 10px;
  }
  .to-ex {
    margin-left: 0;
    margin-right: 10px;
  }
  .el-tabs__nav-scroll {
    overflow-x: auto;
  }
}

.change-post-tonal-modal {
  height: 200px;
}

.change-post-tonal-modal__parent .ant-modal-content {
  background-color: #e8eff5;
  overflow: hidden;
}
.change-post-tonal-modal__parent .ant-modal-body {
  padding: 0;
}
.change-post-tonal-modal__parent .ant-modal-footer,
.change-post-tonal-modal__parent .ant-modal-header {
  background-color: #e8eff5;
  border-color: darken(#e8eff5, 1);
}
.change-post-tonal-modal__parent .ant-modal-footer {
  box-shadow: 0 -2px 4px white;
}
.change-post-tonal-modal__parent .ant-modal-header {
  box-shadow: 0 2px 4px #bbcfda;
}
.change-post-tonal-modal__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 100%;
}
.change-post-tonal-modal__loading .spinner {
  transform: scale(0.5);
}
.change-post-tonal-modal__wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.change-post-tonal-modal__list {
  width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.change-post-tonal-modal__item {
  width: 100%;
  text-align: center;
  padding: 6px 0;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 1px 1px 4px #bbcfda, -1px -1px 4px white;
}
.change-post-tonal-modal__item:not(:last-child) {
  margin-bottom: 10px;
}
.change-post-tonal-modal__item.active {
  color: #fff;
  background: #5e6d82;
  box-shadow: 3px 3px 6px #bbcfda, -3px -3px 6px white;
}
.change-post-tonal-modal__item.active.positive {
  background: #15cf49;
}
.change-post-tonal-modal__item.active.negative {
  background: #e42e34;
}
.change-post-tonal-modal__all {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
}
.change-post-tonal-modal__all .checkbox {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: #e8eff5;
  box-shadow: 1px 1px 4px #bbcfda, -1px -1px 4px white;
}
.change-post-tonal-modal__all .checkbox.active {
  box-shadow: 3px 3px 6px #bbcfda, -3px -3px 6px white;
  background: #1890ff;
}
.change-post-tonal-modal__all span {
  display: block;
  margin-left: 10px;
}
.copy-posts-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 40px;
}
.copy-posts-title {
  font-size: 21px;
  font-weight: 500;
}
</style>
